import { call, put, takeLatest, ForkEffect } from "redux-saga/effects";
import {
  fetchTemplateFailedAction,
  fetchTemplateSuccessAction,
  templateActions,
} from "./actions";
import { IFetchTemplatesAction, IFetchTemplatesSuccessActionPayload } from "./interface";
import { TemplateRepository } from "@common/domain/repositories/TemplateRepository";

function* fetchTemplateSaga(action: IFetchTemplatesAction) {
  
  const category = action?.payload?.category;
  try {
    const response: IFetchTemplatesSuccessActionPayload = yield call(
      TemplateRepository.fetchTemplates,
      action.payload
    );
    response.category = category;

    yield put(fetchTemplateSuccessAction(response));
  } catch (e: any) {
    yield put(
      fetchTemplateFailedAction({
        error: e.message,
        pageNumber: action.payload?.pageNumber,
        category:category
      })
    );
  }
}
export function* watchTemplates(): Generator<ForkEffect> {
  yield takeLatest(templateActions.FETCH_TEMPLATES, fetchTemplateSaga);
}
